import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../main-page.service';
import { ChannelsManagmentComponent } from '../channels-managment/channels-managment.component';
import { ChannelModel } from '../../../../models/parts/channel.model';
import { CrossSectionModel } from '../../../../models/parts/cross-section.model';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { CorosiveProtectionModel } from '../../../../models/dictionaries/corosive-protection.model';
import { MaterialModel } from '../../../../models/dictionaries/material.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;


@Component({
  selector: 'app-channels-grid',
  template: `<!-- <div [hidden]="isConnectorHidden">
    <hc-data-grid id="mainGrid" (onAddClick)="addChannel()" [data]="myArray" [select]="false" [headers]="headers" [subheader]="true" [displayedColumns]="displayedColumns" (onEditClick)="onConnectorClick($event)">
    </hc-data-grid>
</div> -->

<!-- Edit Modal -->
<div class="modal" id="addChannelModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div>
                            <div>
                                <div class="display-flex">
                                    <span class="modal-label">Article no:</span>
                                    <input type="number" [(ngModel)]="templateChannel.articleNumber" formControlName="articleNumber">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="templateChannel.name" formControlName="name">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Description:</span>
                                    <input type="text" [(ngModel)]="templateChannel.description" formControlName="description">
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="select-style" [(ngModel)]="templateChannel.system" class="selectHeight" formControlName="system" (ngModelChange)="filterCrossSections()">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Corrosion protection:</span>
                                    <select name="corrProtSelect" class="select-style" [(ngModel)]="templateChannel.corrosionProtection" formControlName="corrosionProtection">
                                        <option *ngFor="let corrosionProtection of corrosionProtectionsArray | sortByName" [ngValue]="corrosionProtection.name" class="selectHeight">{{corrosionProtection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Cross section:</span>
                                    <select name="crossSectionSelect" class="select-style" [(ngModel)]="templateChannel.crossSection" formControlName="crossSection">
                                        <option *ngFor="let crossSection of availableCrossSectionsArray | sortByName" [ngValue]="crossSection.name">{{crossSection.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex">
                                    <span class="modal-label">Material:</span>
                                    <select name="material" class="select-style" [(ngModel)]="templateChannel.material" formControlName="material">
                                        <option *ngFor="let material of materialsArray | sortByName" [ngValue]="material.name">{{material.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewChannel()">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addChannelModal" (click)="prepareCreate()">Create</button>

<div class="table-wrapper">
    <div class="table-scroll">
        <table>
            <tr>
                <th *ngFor="let header of headers">{{header}}</th>
            </tr>
            <tr *ngFor="let channel of channelGridData,let row_no = index" (click)="onRowClick(row_no, channel._id)" style="cursor:pointer"
                [class.highlighted]="channel._id === selectedRowId">
                <td>{{channel.articleNumber}}</td>
                <td>{{channel.name}}</td>
                <td>{{channel.description}}</td>
                <!-- <td>{{channel.description}}</td> -->
            </tr>
        </table>
    </div>
</div>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.modal-label{width:168px}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.highlighted{background-color:#534f53!important;color:#fff}.select-style{width:100px}`]
})
export class ChannelsGridComponent implements OnInit {
  @Input() channelComponent: ChannelsManagmentComponent;
  isChannelHidden = true;
  channelGridData: ChannelModel[] = [];
  templateChannel = new ChannelModel();
  headers: string[] = ['Article no.', 'Name', 'Description'];
  public selectedRowId;
  public allCrossSectionsArray: CrossSectionModel[] = [];
  public availableCrossSectionsArray: CrossSectionModel[] = [];
  public systemsArray: SystemModel[] = [];
  public corrosionProtectionsArray: CorosiveProtectionModel[] = [];
  public materialsArray: MaterialModel[] = [];
  public formGroup: FormGroup;

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.allCrossSectionsArray = [];
    this.loadData();
    // this.mainPageService.mysubject.subscribe((value) => {
    //   this.updateChannelInDb(value);
    // });
    this.mainPageService.deleteChannelSubject.subscribe((value) => {
      this.channelGridData = this.channelGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadData(): void {
    this.mainPageService.loadAllCrossSections().subscribe((response) => {
      this.allCrossSectionsArray = response;
    });
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
    this.mainPageService.loadAllCorosionProtections().subscribe((response) => {
      this.corrosionProtectionsArray = response;
    });
    this.mainPageService.loadAllChannels().subscribe((response) => {
      this.channelGridData = response;
    });
    this.mainPageService.loadAllMaterials().subscribe((response) => {
      this.materialsArray = response;
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isChannelHidden = !this.isChannelHidden;
  }

  onChannelClick(sender) {
    this.channelComponent.showChannel(sender);
  }

  onRowClick(row, id) {
    this.selectedRowId = id;
    this.channelComponent.showChannel(this.channelGridData[row]);
  }

  updateChannelInDb(id) {
    let dataToSend;
    let preparedData;
    for (const item of this.channelGridData) {
      if (item._id === id) {
        dataToSend = item;
        break;
      }
    }
    for (const item of this.channelGridData) {
      if (item._id === id) {
        preparedData = item;
        break;
      }
    }
    preparedData.articleNumber = dataToSend.articleNumber;
    preparedData.description = dataToSend.description;
    preparedData.name = dataToSend.name;
    this.mainPageService.updateChannelInDb(JSON.stringify(preparedData)).subscribe(() => { });
  }

  saveNewChannel() {
    this.mainPageService.addNewChannelIntoDb(JSON.stringify(this.templateChannel)).subscribe((response) => {
      this.templateChannel._id = response;
      this.channelGridData.push(this.templateChannel);
      this.templateChannel = new ChannelModel();
    });
  }

  public prepareCreate() {
    this.templateChannel = new ChannelModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.templateChannel.name, Validators.required),
      articleNumber: new FormControl(this.templateChannel.articleNumber),
      description: new FormControl(this.templateChannel.description),
      system: new FormControl(this.templateChannel.system, Validators.required),
      corrosionProtection: new FormControl(this.templateChannel.corrosionProtection, Validators.required),
      crossSection: new FormControl(this.templateChannel.crossSection, Validators.required),
      material: new FormControl(this.templateChannel.material, Validators.required),
    });
  }

  public filterCrossSections() {
    this.availableCrossSectionsArray = this.allCrossSectionsArray.filter(x => x.system === this.templateChannel.system);
  }
}
